import { useAuthContext } from "@/providers/auth-provider";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { isEmployeeUserWithEmployeeRole } from "creso-core/utils";

export const Route = createFileRoute("/(auth)/_headed/reports/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { user } = useAuthContext();

  return (
    <Navigate
      to={
        isEmployeeUserWithEmployeeRole(user)
          ? "/reports/change-of-broker"
          : "/reports/brokerage"
      }
    />
  );
}
